import React from 'react';
import {
  StyledNavPropsButton,
  ValuePropsContainer,
  ValuePropsTextDesktop,
  ValuePropsTextMobile,
  PromoLink,
} from './ValuePropsStationery.styles';
import { useTranslation } from 'react-i18next';

interface ValuePropsStationeryProps {}

export const ValuePropsStationery: React.FC<ValuePropsStationeryProps> = () => {
  const { t } = useTranslation('header');

  return (
    <StyledNavPropsButton
      variant="defaultPrimary"
      id="value-props-stationery"
      forwardedAs="a"
      href={t('stationeryValueProps.link')}
      target="_blank"
    >
      <ValuePropsContainer alignItems="center">
        <ValuePropsTextDesktop as="p">{t('stationeryValueProps.titleDesktop')}</ValuePropsTextDesktop>
        <ValuePropsTextMobile as="p">{t('stationeryValueProps.titleMobile')}</ValuePropsTextMobile>
        <PromoLink>{t('stationeryValueProps.cta')}</PromoLink>
      </ValuePropsContainer>
    </StyledNavPropsButton>
  );
};
